/* ===========================================================================
   KC cart drawer: device upsell, memory-card upsell, shipping protection,
   discount code, savings summary.

   WHY IT IS INJECTED RATHER THAN BUILT INTO THE SECTION
   sections/cart-drawer.liquid is re-rendered by the theme on every cart
   change, so anything written into it is thrown away and rebuilt. This module
   watches for that and re-injects, which also means the section file is left
   untouched and the whole feature can be removed by deleting two assets.

   THE LADDER IS THE CART'S, NOT A SEPARATE OFFER
   Kaching discounts on total DEVICE count across different products, verified
   against the live cart on 2026-09-22: 2 devices 8%, 3 devices 10%, and a
   camera plus a doorbell plus an indoor cam all counted together. Memory cards
   are correctly NOT devices -- a camera plus a card stays at 0%. So the upsell
   here is "one more device moves the whole cart up a rung", and the figures it
   quotes are the ones Kaching will actually apply.

   Keep LADDER in step with Kaching by hand. Nothing here charges anything;
   Kaching does, at the cart.
   =========================================================================== */
(function () {
  'use strict';

  /* Devices that count toward the ladder. */
  var DEVICES = [
    { id: 51761813946642, name: 'Solar Cam Pro 3.0',  price: 329, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/Untitleddesign_97_160x.png?v=1765187764' },
    { id: 50981518377234, name: 'Solar Cam 2.0 4G',   price: 329, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/Untitled_design_55_160x.png' },
    { id: 52371307102482, name: 'Lumis Pro',          price: 397, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/Untitleddesign_1_160x.png?v=1781566478' },
    { id: 51980763463954, name: 'Home Guardian',      price: 119, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/Untitled_design_-_2026-02-02T082715.407_160x.png?v=1769985313' },
    { id: 51416958566674, name: 'DoorMate Doorbell',  price: 299, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/main_picture_2_160x.png?v=1753134381' }
  ];

  /* Memory cards. The two big ones only fit the Solar Cam Pro 3.0, so they are
     hidden unless one is in the cart -- offering a card the customer's camera
     cannot read is a refund, not an upsell. */
  /* Card compatibility is per camera, not a single "big cards" flag:
     64GB and 128GB fit everything, 256GB fits the Solar Cam Pro 3.0, the Lumis
     Pro and the DoorMate, 512GB is Solar Cam Pro 3.0 only. `fits: null` means
     any camera.
     Selling a card a customer's camera cannot read is a refund, so a card is
     offered only when a camera that takes it is already in the cart. */
  var SC3_ID   = 51761813946642;
  var LUMIS_ID = 52371307102482;
  var DOOR_ID  = 51416958566674;
  var CARDS = [
    { id: 47470136099090, size: '64GB',  price: 39,  fits: null },
    { id: 47470136131858, size: '128GB', price: 73,  fits: null },
    { id: 51776734757138, size: '256GB', price: 153, fits: [SC3_ID, LUMIS_ID, DOOR_ID] },
    { id: 51776736166162, size: '512GB', price: 299, fits: [SC3_ID] }
  ];
  var CARD_IMG = 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/64gb-tf-micro-card-481118_61d8b380-b7fe-40e5-a3e8-a091744cf7d0_160x.jpg?v=1699890606';

  var SHIP_ID = 52729829982482;
  var SHIP_PRICE = 4.99;

  /* devices -> percent off. Mirrors the Kaching device ladder. */
  function pctFor(n) {
    if (n >= 5) return 15;
    if (n === 4) return 12;
    if (n === 3) return 10;
    if (n === 2) return 8;
    return 0;
  }

  var OPT_OUT = 'kcShipProtOff';   /* set once the shopper turns protection off */
  var shipTried  = false;              /* auto-add fires once per PAGE LOAD, not per redraw.
                                          A session-wide flag made it stick off for the rest
                                          of the visit, so protection was not actually on. */
  var DEV_ADDED  = 'kcDeviceAdded';    /* the device offer is a one-shot, not a nag */
  var busy = false;

  function money(n) {
    return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function money0(n) {
    return '$' + Math.round(Number(n)).toLocaleString('en-AU');
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        /* Shopify answers a refused add with JSON AND a 4xx. Resolving on that
           made every failure look like a success: the line was never added, yet
           the caller repainted as though it had been. */
        if (!r.ok) {
          var e = new Error(j.description || j.message || ('Cart request failed (' + r.status + ')'));
          e.status = r.status;
          throw e;
        }
        return j;
      });
    });
  }
  /* Tell the theme to re-render from the server.

     ONLY 'cart:refresh'. The theme's own 'cart:change' carries a payload --
     it dispatches { detail: { baseEvent, cart } } where cart also holds the
     rendered `sections` -- and every listener reads it without guarding:
       document.addEventListener('cart:change', e => fetchCart = e.detail.cart)
       CartCount:      e.detail.cart.item_count
       cart-drawer:    e.detail.cart.sections[sectionId]
       free-ship bar:  e.detail.cart.items.filter(...)
     Firing it bare threw in all of them, so the header count, the shipping
     progress bar and the drawer's own re-render silently stopped updating and
     PostHog logged ~800 exceptions a day from the day this shipped.
     'cart:refresh' takes no detail by design: the drawer refetches its section
     and CartCount re-reads the cart, which is exactly what is wanted here. */
  var refreshQueued = false;
  function refresh() {
    /* Never ask the theme to redraw under a finger -- see handsOff. But a
       blocked redraw must not be dropped: the shopper who just flipped the
       protection toggle is standing in the footer, so their own change would
       be the one that never lands. Hold it and retry until the hand lifts. */
    if (handsOff()) {
      if (refreshQueued) return;
      refreshQueued = true;
      window.setTimeout(function () { refreshQueued = false; refresh(); }, 300);
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* --------------------------------------------------------- checkout guard

     The theme answers 'cart:refresh' by REPLACING every child of #cart-drawer,
     footer and buy-buttons form included. Two ways that loses a sale:

       1. It lands between the shopper's finger going down and the click
          resolving. The button they aimed at no longer exists, so the tap hits
          nothing and nothing happens -- the reported "I click checkout and it
          doesn't load".
       2. It lands after submit. A form has to be connected to a document to
          submit, so replacing it cancels the navigation outright, and
          CustomButton has already swapped the label for its three dots.

     The window is not theoretical: the shipping-protection auto-add fires a
     write the instant the drawer opens, which is exactly when a quick shopper
     is reaching for Checkout.

     So once a finger is on the footer, or a checkout submit is in flight, we
     hold off the two things that can destroy that form: refresh(), which asks
     the theme to replace the drawer, and maybeAddProtection(), which starts a
     write that ends in a refresh().

     inject() and render() are deliberately NOT held off. clearOurs() only ever
     removes our own nodes -- .kc-cart-built, .kc-sp, .kc-sv, .kc-dc, .kc-was --
     and never form.buy-buttons, so our own paint cannot take the button away.
     Holding them off would be actively wrong: the protection toggle lives in
     the footer, so flipping it puts a finger there, and gating the paint on
     that would leave the shopper's own change unpainted. */
  var checkingOut = false;      /* submit fired; hands off until we navigate */
  var handsOffUntil = 0;        /* ms timestamp; a pointer is on the footer */
  function handsOff() { return checkingOut || Date.now() < handsOffUntil; }

  /* After any write, re-read the cart and repaint from THAT, not from whatever
     was cached before the write. Calling refresh() alone let a fetch already in
     flight -- issued before the write landed -- win the race and repaint stale
     state, which is what flipped the protection toggle straight back off. */
  function commit() {
    return getCart().then(function (cc) {
      lastCart = cc;
      builtFor = null;                 /* force a repaint even if the DOM looks built */
      quietly(function () { inject(cc); });
      refresh();                       /* let the theme redraw its own totals */
      return cc;
    });
  }

  function deviceInfo(cart) {
    var count = 0, subtotal = 0, cards = 0, hasSC3 = false, hasCard = false, hasShip = false;
    var ids = {};
    (cart.items || []).forEach(function (it) {
      var d = DEVICES.filter(function (x) { return x.id === it.id; })[0];
      if (d) { count += it.quantity; subtotal += (it.original_line_price / 100); ids[it.id] = true; }
      if (it.id === SC3_ID) hasSC3 = true;
      if (CARDS.some(function (c) { return c.id === it.id; })) { hasCard = true; cards += it.quantity; }
      if (it.id === SHIP_ID) hasShip = true;
    });
    return { count: count, subtotal: subtotal, cards: cards, ids: ids,
             hasSC3: hasSC3, hasCard: hasCard, hasShip: hasShip };
  }

  /* ---------------------------------------------------------------- blocks */

  function buildDeviceUpsell(cart, info) {
    var next = pctFor(info.count + 1), cur = pctFor(info.count);
    if (info.count < 1 || next <= cur) return null;          /* nothing to unlock */

    /* Offer it once. Once the shopper has taken it, the drawer falls back to
       the small add-ons rather than asking for another camera. */
    try { if (sessionStorage.getItem(DEV_ADDED) === '1') return null; } catch (e) {}

    var box = el('div', 'kc-cu kc-cu--device');
    var head = el('div', 'kc-cu__head');
    head.appendChild(el('b', null, 'Add 1 more device'));
    head.appendChild(el('span', 'kc-cu__pill', 'SAVE ' + next + '%'));
    box.appendChild(head);

    var row = el('div', 'kc-cu__row');
    var thumb = el('img', 'kc-cu__img'); thumb.loading = 'lazy'; thumb.alt = '';
    row.appendChild(thumb);

    var sel = el('select', 'kc-cu__select');
    sel.setAttribute('aria-label', 'Choose a device to add');
    DEVICES.forEach(function (d) {
      var o = el('option', null, d.name + ' — ' + money0(d.price));
      o.value = String(d.id);
      sel.appendChild(o);
    });
    var mid = el('div', 'kc-cu__mid');
    mid.appendChild(sel);
    var prices = el('div', 'kc-cu__prices');
    var was = el('s', 'kc-cu__was');
    var now = el('b', 'kc-cu__now');
    prices.appendChild(was); prices.appendChild(now);
    mid.appendChild(prices);
    var saveTag = el('span', 'kc-cu__save');
    mid.appendChild(saveTag);
    var scope = el('span', 'kc-cu__scope', next + '% comes off this device and the ones already in your cart');
    mid.appendChild(scope);
    row.appendChild(mid);

    var btn = el('button', 'kc-cu__btn', 'ADD TO CART');
    btn.type = 'button';
    row.appendChild(btn);
    box.appendChild(row);

    function paint() {
      var d = DEVICES.filter(function (x) { return String(x.id) === sel.value; })[0];
      if (!d) return;
      thumb.src = d.img;
      /* Price the device being added, on its own. The ladder also discounts
         what is already in the cart, but quoting the whole basket here reads
         like the price of this one item and confuses people. */
      var gross = d.price;
      var net = gross * (1 - next / 100);
      was.textContent = money(gross);
      now.textContent = money(net);
      saveTag.textContent = 'SAVE ' + money(gross - net);
    }
    sel.addEventListener('change', paint);
    paint();

    btn.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      btn.disabled = true;
      btn.textContent = 'ADDING…';
      post('/cart/add.js', { items: [{ id: Number(sel.value), quantity: 1 }] })
        .then(function () {
          try { sessionStorage.setItem(DEV_ADDED, '1'); } catch (e) {}
          return commit();
        })
        .catch(function () { btn.textContent = 'ADD TO CART'; })
        .finally(function () { busy = false; });
    });
    return box;
  }

  function cardFits(card, info) {
    if (!card.fits) return true;                 /* fits every camera */
    for (var i = 0; i < card.fits.length; i++) {
      if (info.ids[card.fits[i]]) return true;   /* a camera that takes it is in the cart */
    }
    return false;
  }

  function buildCardUpsell(cart, info) {
    /* One card per camera, same rule as the buy box. Once they hold as many
       cards as cameras there is nothing left to sell them here. */
    var room = info.count - info.cards;
    if (info.count < 1 || room < 1) return null;

    var box = el('div', 'kc-cu kc-cu--card');
    var head = el('div', 'kc-cu__head');
    head.appendChild(el('b', null, 'Add Micro TF Cards'));
    head.appendChild(el('span', 'kc-cu__pill kc-cu__pill--ink', '$0/MONTH'));
    box.appendChild(head);

    var row = el('div', 'kc-cu__row');
    var thumb = el('img', 'kc-cu__img'); thumb.src = CARD_IMG; thumb.loading = 'lazy'; thumb.alt = '';
    row.appendChild(thumb);

    var mid = el('div', 'kc-cu__mid');
    var sel = el('select', 'kc-cu__select');
    sel.setAttribute('aria-label', 'Choose a memory card size');
    CARDS.filter(function (c) { return cardFits(c, info); }).forEach(function (c) {
      var o = el('option', null, c.size + ' \u2014 ' + money0(c.price));
      o.value = String(c.id);
      sel.appendChild(o);
    });
    mid.appendChild(sel);

    /* Quantity, capped at one per camera. With a single camera there is only
       ever one choice, so the control would be furniture. */
    var qty = null;
    if (room > 1) {
      qty = el('select', 'kc-cu__select kc-cu__qty');
      qty.setAttribute('aria-label', 'How many cards');
      for (var i = 1; i <= room; i++) {
        var o = el('option', null, i + (i === 1 ? ' card' : ' cards'));
        o.value = String(i);
        qty.appendChild(o);
      }
      mid.appendChild(qty);
    }

    var scope = el('span', 'kc-cu__scope');
    mid.appendChild(scope);
    row.appendChild(mid);

    var btn = el('button', 'kc-cu__btn', 'ADD');
    btn.type = 'button';
    row.appendChild(btn);
    box.appendChild(row);

    function paint() {
      var c = CARDS.filter(function (x) { return String(x.id) === sel.value; })[0];
      var q = qty ? Number(qty.value) : 1;
      var note = '';
      if (c && c.fits) {
        var names = c.fits.map(function (id) {
          var d = DEVICES.filter(function (x) { return x.id === id; })[0];
          return d ? d.name : '';
        }).filter(Boolean);
        if (names.length) note = ' Fits ' + names.join(' and ') + '.';
      }
      scope.textContent = (room > 1 ? 'One per camera \u2014 up to ' + room + '. ' : '') +
        'Keep and replay your footage without a subscription.' + note +
        (c ? '  ' + money0(c.price * q) : '');
    }
    sel.addEventListener('change', paint);
    if (qty) qty.addEventListener('change', paint);
    paint();

    btn.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      btn.disabled = true;
      btn.textContent = 'ADDING\u2026';
      post('/cart/add.js', { items: [{ id: Number(sel.value), quantity: qty ? Number(qty.value) : 1 }] })
        .then(commit)
        .catch(function () { btn.textContent = 'ADD'; btn.disabled = false; })
        .finally(function () { busy = false; });
    });
    return box;
  }

  function buildShipProtection(cart, info) {
    if (!(cart.items || []).length) return null;

    var box = el('label', 'kc-sp');
    var cb = el('input');
    cb.type = 'checkbox';
    cb.className = 'kc-sp__cb';
    cb.checked = info.hasShip;
    box.appendChild(cb);
    box.appendChild(el('span', 'kc-sp__track'));

    var txt = el('span', 'kc-sp__txt');
    txt.appendChild(el('b', null, 'Shipping Protection'));
    txt.appendChild(el('span', null, 'In case of loss or damage in transit'));
    box.appendChild(txt);

    var right = el('span', 'kc-sp__right');
    right.appendChild(el('b', null, money(SHIP_PRICE)));
    right.appendChild(el('span', 'kc-sp__badge', 'Guaranteed delivery'));
    box.appendChild(right);

    var warn = el('span', 'kc-sp__warn');
    warn.hidden = true;
    box.appendChild(warn);

    cb.addEventListener('change', function () {
      if (busy) { cb.checked = !cb.checked; return; }
      busy = true;
      warn.hidden = true;
      if (cb.checked) {
        try { sessionStorage.removeItem(OPT_OUT); } catch (e) {}
        post('/cart/add.js', { items: [{ id: SHIP_ID, quantity: 1 }] })
          .then(commit)
          .catch(function (err) {
            cb.checked = false;
            warn.textContent = err.message || 'Could not add protection.';
            warn.hidden = false;
          })
          .finally(function () { busy = false; });
      } else {
        /* Remember the choice, or the auto-add below would put it straight back. */
        try { sessionStorage.setItem(OPT_OUT, '1'); } catch (e) {}
        var line = (cart.items || []).filter(function (i) { return i.id === SHIP_ID; })[0];
        if (!line) { busy = false; return; }
        post('/cart/change.js', { id: line.key, quantity: 0 })
          .then(commit).finally(function () { busy = false; });
      }
    });
    return box;
  }

  function decorateTotal(footer, cart) {
    var orig = cart.original_total_price, now = cart.total_price;
    if (!(orig > now)) return;
    var first = footer.querySelector('.h5');
    var row = first ? first.closest('.h-stack') : null;
    if (!row) return;
    var cells = row.querySelectorAll('.h5');
    var value = cells[cells.length - 1];
    if (!value || value === first || value.querySelector('.kc-was')) return;
    value.insertBefore(el('s', 'kc-was', money(orig / 100)), value.firstChild);
  }

  function buildSavings(cart) {
    var saved = (cart.original_total_price - cart.total_price) / 100;
    if (saved <= 0) return null;
    var box = el('div', 'kc-sv');
    box.appendChild(el('span', 'kc-sv__label', 'Total Savings:'));
    box.appendChild(el('b', 'kc-sv__amt', money(saved)));
    return box;
  }

  function buildDiscount() {
    var box = el('form', 'kc-dc');
    var input = el('input', 'kc-dc__input');
    input.type = 'text';
    input.placeholder = 'Discount code';
    input.setAttribute('aria-label', 'Discount code');
    var btn = el('button', 'kc-dc__btn', 'Apply');
    btn.type = 'submit';
    box.appendChild(btn); box.appendChild(input);   /* Apply on the left, clear of the chat bubble */
    box.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (input.value || '').trim();
      if (!code) return;
      /* /discount/CODE is the only route that actually applies a code to the
         session. Flag the drawer to reopen so the shopper lands back where
         they were rather than on a bare page. */
      try { sessionStorage.setItem('kcOpenDrawer', '1'); } catch (e2) {}
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/';
    });
    return box;
  }

  /* ---------------------------------------------------------------- inject */

  /* The theme rebuilds the drawer's innards from the server on every cart
     change, which wipes our markup. Re-fetching the cart before repainting
     leaves a visible hole for the length of a round trip -- that is the flash.
     So we keep the last cart, repaint from it synchronously the moment our
     markup disappears, and only swap in fresh numbers once they arrive. */
  var lastCart = null;
  var builtFor = null;      /* fingerprint of the cart the current DOM shows */
  var mo = null;

  function drawerEl() { return document.querySelector('#cart-drawer'); }

  function fingerprint(cart) {
    return (cart.items || []).map(function (i) { return i.id + 'x' + i.quantity; }).join(',') +
           '|' + cart.total_price + '|' + cart.original_total_price;
  }

  /* Our own writes must not feed the observer, or injecting re-triggers a
     render which injects again. */
  function quietly(fn) {
    var d = drawerEl();
    if (mo) mo.disconnect();
    try { fn(); } finally { if (mo && d) mo.observe(d, { childList: true, subtree: true }); }
  }

  function clearOurs(drawer) {
    ['.kc-cart-built', '.kc-sp', '.kc-sv', '.kc-dc', '.kc-was'].forEach(function (s) {
      var n = drawer.querySelectorAll(s);
      for (var i = 0; i < n.length; i++) n[i].remove();
    });
  }

  /* Protection is controlled by the toggle in the footer, so the line for it in
     the item list is a second, contradictory control -- with its own quantity
     box and Remove link. Hide the line and take it out of the drawer's count so
     the badge matches the rows on screen. Keyed off the variant id in
     data-line-key, not the product title, so a rename cannot break it. */
  function hideProtectionLine(drawer, cart) {
    var items = drawer.querySelector('.cart-drawer__line-items');
    if (items) {
      var lines = items.querySelectorAll('line-item, .line-item');
      for (var i = 0; i < lines.length; i++) {
        var k = lines[i].querySelector('[data-line-key]');
        var key = k ? (k.getAttribute('data-line-key') || '') : '';
        var a = lines[i].querySelector('a[href*="/products/"]');
        var href = a ? (a.getAttribute('href') || '') : '';
        if (key.indexOf(SHIP_ID + ':') === 0 || href.indexOf('/products/shipping-protection') > -1) {
          lines[i].classList.add('kc-line-hidden');
        }
      }
    }
    var ship = 0;
    (cart.items || []).forEach(function (it) { if (it.id === SHIP_ID) ship += it.quantity; });
    if (!ship) return;
    var shown = Math.max(0, (cart.item_count || 0) - ship);
    var bubbles = drawer.querySelectorAll('cart-count');
    /* Only write when it actually differs. The theme's CartCount animates on
       every change, so a redundant write is a visible twitch. */
    for (var j = 0; j < bubbles.length; j++) {
      if (bubbles[j].textContent !== String(shown)) bubbles[j].textContent = String(shown);
    }
  }

  function inject(cart) {
    var drawer = drawerEl();
    if (!drawer) return;

    var items = drawer.querySelector('.cart-drawer__line-items');
    var footer = drawer.querySelector('[slot="footer"]');
    if (!items || !footer) return;

    var fp = fingerprint(cart);
    if (drawer.querySelector('.kc-cart-built') && builtFor === fp) return;   /* already correct */

    clearOurs(drawer);

    var info = deviceInfo(cart);

    var wrap = el('div', 'kc-cart-built');
    [buildDeviceUpsell(cart, info), buildCardUpsell(cart, info)].forEach(function (b) {
      if (b) wrap.appendChild(b);
    });
    items.insertAdjacentElement('afterend', wrap);

    var sp = buildShipProtection(cart, info);
    if (sp) footer.insertAdjacentElement('afterbegin', sp);

    var form = footer.querySelector('form.buy-buttons');
    if (form) form.insertAdjacentElement('beforebegin', buildDiscount());

    decorateTotal(footer, cart);

    var sv = buildSavings(cart);
    if (sv) {
      var total = footer.querySelector('.h5');
      var host = total ? total.closest('.h-stack') : null;
      if (host) host.insertAdjacentElement('afterend', sv);
      else footer.insertAdjacentElement('afterbegin', sv);
    }

    hideProtectionLine(drawer, cart);

    builtFor = fp;

    maybeAddProtection(cart, info);
  }

  /* Protection goes on by default, but only the first time a session sees a
     non-empty cart. Doing it on every drawer open would re-add what the
     shopper just removed, and each add forces the theme to redraw. */
  function maybeAddProtection(cart, info) {
    if (busy || handsOff()) return;

    /* Repair: an earlier build could re-add protection on every redraw, so a
       cart may carry several. One is all anyone needs. */
    var line = (cart.items || []).filter(function (i) { return i.id === SHIP_ID; })[0];
    if (line && line.quantity > 1) {
      busy = true;
      post('/cart/change.js', { id: line.key, quantity: 1 })
        .then(commit).finally(function () { busy = false; });
      return;
    }

    if (info.hasShip || shipTried || !(cart.items || []).length) return;
    var optedOut = false;
    try { optedOut = sessionStorage.getItem(OPT_OUT) === '1'; } catch (e) {}
    if (optedOut) return;                 /* they turned it off; leave it off */

    shipTried = true;                     /* stops the redraw loop within this load */
    busy = true;
    post('/cart/add.js', { items: [{ id: SHIP_ID, quantity: 1 }] })
      .then(commit)
      .catch(function () { /* refused: leave shipTried set, do not hammer it */ })
      .finally(function () { busy = false; });
  }

  /* Repaint from cache first (instant), then reconcile with the server. */
  var pending = false, dirty = false;
  function render() {
    if (!drawerEl()) return;
    if (lastCart) quietly(function () { inject(lastCart); });
    if (pending) { dirty = true; return; }   /* re-run after, never just drop it */
    pending = true;
    getCart().then(function (c) {
      lastCart = c;
      quietly(function () { inject(c); });
    }).catch(function () {}).finally(function () {
      pending = false;
      if (dirty) { dirty = false; render(); }
    });
  }

  /* Gorgias floats its launcher bottom-right, on top of the drawer footer.
     Flag the open state on <html> so the stylesheet can take it out of the
     way while the drawer is up. */
  function trackOpen() {
    var drawer = drawerEl();
    if (!drawer) return;
    var sync = function () {
      var open = drawer.hasAttribute('open');
      if (!open) {
        var r = drawer.getBoundingClientRect();
        open = r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth &&
               getComputedStyle(drawer).visibility !== 'hidden';
      }
      document.documentElement.classList.toggle('kc-drawer-open', !!open);
    };
    new MutationObserver(sync).observe(drawer, {
      attributes: true, attributeFilter: ['open', 'class', 'style', 'aria-hidden']
    });
    drawer.addEventListener('transitionend', sync);
    document.addEventListener('click', function () { setTimeout(sync, 60); }, true);
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setTimeout(sync, 60); });
    sync();
  }

  function watch() {
    var drawer = drawerEl();
    if (!drawer) return;
    mo = new MutationObserver(function () {
      if (!drawer.querySelector('.kc-cart-built')) render();
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  /* Arms the two guards above, and puts a deadline on the button's busy state.
     CustomButton swaps the Checkout label for three animated dots on submit and
     only restores it on pageshow. If the navigation never happens -- blocked in
     the theme editor, cancelled by an app, a dropped connection -- the shopper
     is left staring at a dead button with no way to retry. */
  function guardCheckout() {
    function inFooter(e) {
      var t = e.target;
      return !!(t && t.closest && t.closest('#cart-drawer [slot="footer"]'));
    }

    /* Down: hold off. 1.5s is only a ceiling for a press that never resolves. */
    document.addEventListener('pointerdown', function (e) {
      if (inFooter(e)) handsOffUntil = Date.now() + 1500;
    }, true);

    /* Up: the click has landed, so release almost immediately. Without this the
       protection toggle -- which lives in the footer -- would sit on its own
       held-off redraw for the full ceiling, and the total would lag behind the
       shopper's own tap. A checkout submit fires after this and sets
       checkingOut, which keeps the hold regardless. */
    document.addEventListener('click', function (e) {
      if (inFooter(e)) handsOffUntil = Date.now() + 150;
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('buy-buttons')) return;
      checkingOut = true;
      var btn = form.querySelector('button[name="checkout"]');
      window.setTimeout(function () {
        if (!checkingOut) return;          /* navigated, or already released */
        checkingOut = false;
        if (btn) btn.removeAttribute('aria-busy');
        render();                          /* put the drawer back in a usable state */
      }, 10000);
    }, true);

    /* Back button / bfcache returns the shopper to a live page. */
    window.addEventListener('pageshow', function () { checkingOut = false; });
  }

  function boot() {
    render();
    watch();
    trackOpen();
    guardCheckout();
    ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(render, 250); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
